export default {
  agreeTitle:
    'Umowa o Świadczenie Usług Marketingowych Poprzez "acbuy Affiliate" Na Stronie Internetowej acbuy',
  agreementText: `Witamy w rejestracji na stronie acbuy i korzystaniu z usług marketingowych "acbuy Affiliate". Niniejsza Umowa zostaje zawarta pomiędzy partnerami "acbuy Affiliate" (zwanymi dalej "Stroną B") a acbuy (zwanym dalej "Stroną A") (w tym między innymi www.acbuy.com, aplikacja mobilna acbuy itp., zwane dalej "Stroną Internetową Strony A") w zakresie kwestii związanych z usługami marketingowymi "acbuy Affiliate". Strona B powinna dokładnie zapoznać się z całą treścią niniejszej umowy, szczególnie z częściami pogrubionymi, przed rozpoczęciem korzystania z usług marketingowych "acbuy Affiliate" na stronie acbuy. Kliknięcie przycisku "Przeczytałem i zgadzam się" oznacza, że Strona B zaakceptowała i zgodziła się przestrzegać postanowień niniejszej umowy. Umowa stanowi porozumienie między Stroną B a acbuy i ma moc prawną. acbuy ma prawo do jednostronnego wprowadzania zmian w artykułach niniejszej umowy w oparciu o potrzeby biznesowe, a acbuy zobowiązuje się do natychmiastowego opublikowania takich zmian na Stronie Internetowej Strony A w przypadku jakichkolwiek modyfikacji artykułów umowy. Strona B powinna natychmiast zaprzestać korzystania z usług marketingowych w kanale "acbuy Affiliate" w przypadku braku zgody na zmiany w treści umowy, w przeciwnym razie uznaje się, że Strona B wyraża zgodę na zmiany w treści umowy.
Artykuł 1 Definicje 1. Konsument: oznacza członka acbuy, który uzyskuje dostęp do Strony Internetowej Strony A w celu rejestracji `,
  dashboard: 'Panel',
  hi: 'Cześć, ',
  inviteFriends: 'Zapraszaj znajomych',
  inviteFriendsTips:
    'Zaproś znajomych do acbuy, zarabiaj więcej! Im więcej zaprosisz, tym więcej zarobisz, bez limitu.',
  inviteFriendsTips1: 'Zaproś 3 aktywne konta, aby zarabiać prowizje',
  totalInvite: 'Rejestracje',
  myTeam: 'Mój zespół ',
  extractMoney: 'Gotowe do wypłaty',
  noExtractMoney: 'Niezrealizowane',
  inviteTitle: 'Zaproś znajomych',
  copyCode: 'Skopiuj kod zaproszenia',
  poster: 'Grafika promocyjna',
  myLevel: 'Moje uprawnienia ',
  youLevel: 'Twój poziom',
  commissionRate: 'Prowizja',
  experienceValue: 'Poziom ({num}/{total})',
  levelDesc: 'Opis poziomu',
  invite: 'Zaproś',
  revenueDetails: 'Szczegóły zaproszenia',
  registerTime: 'Czas rejestracji',
  inviteType: 'Związek zaproszenia',
  userMail: 'Adres e-mail użytkownika',
  bonus: 'Bonus',
  myBonus: 'Moje bonusy',
  myBalance: 'My balance',
  applyWithdraw: 'Wypłać',
  withdrawTips:
    'Wskazówka: Ze względu na opłaty transakcyjne związane z wypłatą, zalecana jest wypłata kwoty wyższej niż 500,00 ¥',
  bank: 'Bank',
  paypalAccount: 'Konto PayPal',
  bankAccount: 'Konto bankowe',
  bankName: 'Nazwa banku',
  withdrawAmount: 'Kwota wypłaty ({unit})',
  bonusDetail: 'Szczegóły bonusu',
  directCommission: 'Szczegóły prowizji bezpośredniej',
  indirectCommission: 'Szczegóły prowizji pośredniej',
  tradeTime: 'Czas transakcji',
  packNo: 'Numer pakietu',
  actCommission: 'Prowizja rzeczywista',
  settlementTime: 'Data wysłania paczki',
  levelName: 'Poziom ambasadora',
  packStatus: 'Status pakietu',
  directExplain: 'Stawka prowizji',
  indirectExplain: `Prowizja za wysyłkę drugorzędnych zaproszonych`,
  experienceExplain: 'Wymagane doświadczenie',
  withdrawRecord: 'Wypłata',
  withdrawTime: 'Czas wypłaty',
  serialNo: 'Numer seryjny',
  withdrawStatus: 'Status wypłaty',
  team: 'Zespół',
  levelUp: 'Przejdź na wyższy poziom',
  teamInfo: 'Informacje o zespole',
  teamNum: 'Liczba użytkowników w zespole',
  monthCommission: 'Szacowana kwota za ten miesiąc',
  accCommission: 'Całkowite zarobki',
  teamMember: 'Członek zespołu',
  promotedMember: 'Promowany członek',
  invitationTime: 'Data zaproszenia',
  inviter: 'Zapraszający',
  promotionTime: 'Data promocji',
  IBAN: 'IBAN',
  swiftCode: 'Kod swift',
  bankAddress: 'Adres banku',
  setting: 'Ustawienia',
  profile: 'Profil',
  withdrawMethod: 'Metoda wypłaty',
  myPrerogative: 'Moje korzyści',
  verifyEmail: 'Zweryfikuj swojego e-maila',
  sendCodeTips:
    'Wysłaliśmy kod weryfikacyjny na <strong>{email}</strong>. Wprowadź kod poniżej, aby go zweryfikować.',
  noGetEmail: `Nie otrzymałeś e-maila?`,
  codeErrorTips: 'Kod błędny, spróbuj ponownie',
  resendTime: 'Wyślij ponownie kod ({time}s)',
  or: 'lub',
  contactService: 'Skontaktuj się z pomocą',
  addMethod: 'Nowa metoda wypłaty',
  editMethod: 'Edytuj metodę wypłaty',
  rePaypalAccount: 'Powtórz e-mail PayPal',
  directInvite: 'Zaproszenia bezpośrednie',
  indirectInvite: 'Zaproszenia pośrednie',
  noSameAccount: 'Adresy e-mail konta PayPal się różnią',
  noAddWithdrawMethod: `Nie dodałeś metody wypłaty`,
  statusEnum: {
    0: 'Do wypłaty',
    1: 'W trakcie wypłaty',
    2: 'Wypłata zakończona',
    3: 'Wypłata nieudana',
    4: 'Wypłata anulowana'
  },
  userDetail: 'Szczegóły użytkownika',
  balance: 'Balans',
  withdrawMax: 'Kwota większa niż ¥500.00',
  addPaypalAccount: 'Dodaj konto PayPal',
  addBankAccount: 'Dodaj konto bankowe',
  noPaypalAccount: 'Brak konta PayPal',
  noBankAccount: 'Brak konta bankowego',
  estimated: 'Dostawa',
  notEstimated: 'Nie dostarczono',
  actual: 'faktyczny',
  estiamte: 'oszacowanie',
  directRealtion: 'Bezpośrednia relacja',
  indirectRealtion: 'Relacje pośrednie',
  experienceValueText: 'Wartość doświadczalna',
  relatedParcel: 'Powiązana paczka',
  empiricalValue: 'Wartość doświadczalna',
  acquiringTime: 'Czas pozyskania',
  relatedEmail: 'Powiązany e-mail',
  relatedUsers: 'Powiązani użytkownicy',
  balanceDetail: 'Szczegóły salda',
  commissionDetail: 'Szczegóły prowizji',
  details: 'Szczegóły',
  question1:
    'Po zakończeniu torby przez zaproszenego użytkownika jego status zostanie zaktualizowany na "aktywowany"',
  question2:
    'Zamówienie zostało zrealizowane i prowizja została przeniesiona na Twoje konto salda',
  question3:
    'Komisja za wszystkie zlecenia "niepotwierdzone odbiory". Zamówienie zostanie zweryfikowane w ciągu 30-60 dni, a następnie prowizja zostanie przekazana na Twoje konto salda',
  activatedUser: 'Aktywowany użytkownik',
  bankTip: 'Opłata za obsługę wypłaty: 2% kwoty wypłaty',
  selectWithdrawMethod: 'Wybierz konto wypłaty',
  currentWithdrawAmount: 'Bieżąca kwota wypłacana',
  modify: 'modyfikuj',
  bonusBalance: 'Dostępne saldo premii',
  balanceTips1:
    '1.Wypłata premii rozliczeniowej za poprzedni miesiąc w dniu 1(UTC+8) każdego miesiąca',
  balanceTips2:
    '2.Pierwszy (UTC+8) do dziesiątego (UTC+8) każdego miesiąca jest datą wypłaty i możesz wybrać wypłatę z pierwszego (UTC+8) do dziesiątego (UTC+8). Przekażemy Ci środki przed 20-tym(UTC+8), a po dokonaniu przelewu poinformujemy Cię o wyniku przelewu mailem. Jednocześnie możesz sprawdzić informacje związane z przelewem w rejestrze wypłaty.',
  income: 'dochody',
  expenditure: 'Wydatki',
  commissionSettlement: 'Rozliczenie prowizji',
  commissionWithdrawal: 'Wycofanie Komisji',
  withdrawalCancellation: 'anulowanie wypłaty',
  activeStatus: 'Status aktywacji',
  settlePackageNum: 'Liczba opakowań',
  activeTime: 'Czas aktywacji',
  orderTime: 'Czas wysłania paczki',
  orderUser: 'Zamów użytkownika',
  actualFreight: 'Rzeczywista płatność za frachty',
  estimatedCommission: 'Szacunkowa prowizja',
  withdrawAccount: 'Konto do wypłaty',
  withdrawType: 'Rodzaj wypłaty',
  withdrawTypeEnum: {
    2: 'Wycofanie do salda',
    0: 'Wypłata do banku'
  },
  applyTime: 'Harmonogram składania wniosków',
  withdrawStatusEnum: {
    0: 'Przegląd',
    1: 'Wycofanie',
    2: 'Wycofać sukces',
    3: 'Odpady wycofania',
    4: 'Wycofanie anulowania'
  },
  bankEndNumber: 'Numer końcowy karty bankowej',
  cancelWithdraw: 'Anuluj wypłatę',
  withdrawalDetails: 'Szczegóły dotyczące wycofania',
  transferVoucher: 'Voucher transferowy',
  cancelWithdrawConfirm: 'Anuluj potwierdzenie wypłaty',
  delPackageHint:
    'Po potwierdzeniu anulowania wypłaty, odpowiednia kwota wypłaty zostanie zwrócona na saldo prowizji',
  withdrawTip:
    'Pierwszy (UTC+8) - 10th (UTC+8) każdego miesiąca to dni wypłaty i możesz wybrać wypłatę od pierwszego do dziesiątego',
  hasLogOff: 'Anulowane'
};
